import { Card } from 'react-bootstrap'

interface WidgetProps {
  stats: string | number
  title: string
}

const Widget = ({ stats, title }: WidgetProps) => {
  return (
    <Card className="h-100" style={{ minWidth: '200px' }}>
      <Card.Body>
        <div className="d-flex">
          <div className="flex-grow-1">
            <span className="text-muted text-uppercase fs-12 fw-bold">
              {title}
            </span>
            <h3 className="mb-0">{stats}</h3>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default Widget
